import { render, staticRenderFns } from "./ModalExibirCameraNaTarja.vue?vue&type=template&id=5b5378da"
import script from "./ModalExibirCameraNaTarja.vue?vue&type=script&lang=js"
export * from "./ModalExibirCameraNaTarja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports